var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _path, _rect26, _rect27, _rect28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockerLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#F5F8FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 66,
    width: 3,
    height: 6,
    rx: 1.5,
    fill: "#666666"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 66,
    width: 3,
    height: 6,
    rx: 1.5,
    fill: "#666666"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 28,
    width: 20,
    height: 40,
    rx: 3,
    fill: "#1E78E1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 32,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#DEDEDE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 36,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#DEDEDE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 40,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#DEDEDE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 49,
    width: 1,
    height: 3,
    rx: 0.5,
    fill: "#DEDEDE"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 47,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "#FFD56A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 66,
    width: 3,
    height: 6,
    rx: 1.5,
    fill: "#666666"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 66,
    width: 3,
    height: 6,
    rx: 1.5,
    fill: "#666666"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 28,
    width: 20,
    height: 40,
    rx: 3,
    fill: "#1E78E1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 32,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#DEDEDE"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 36,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#DEDEDE"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 40,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#DEDEDE"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 49,
    width: 1,
    height: 3,
    rx: 0.5,
    fill: "#DEDEDE"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 47,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "#FFD56A"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 66,
    width: 3,
    height: 6,
    rx: 1.5,
    fill: "#666666"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 66,
    width: 3,
    height: 6,
    rx: 1.5,
    fill: "#666666"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 28,
    width: 20,
    height: 40,
    rx: 3,
    fill: "#4FA5F4"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 32,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#DEDEDE"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 36,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#DEDEDE"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 40,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#DEDEDE"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 49,
    width: 1,
    height: 3,
    rx: 0.5,
    fill: "#DEDEDE"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 47,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "#FFD56A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_1222",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 28,
    width: 60,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 31C21 29.3431 22.3431 28 24 28H38C39.6569 28 41 29.3431 41 31C41 29.3431 42.3431 28 44 28H58C59.6569 28 61 29.3431 61 31C61 29.3431 62.3431 28 64 28H78C79.6569 28 81 29.3431 81 31V65C81 66.3062 80.1652 67.4175 79 67.8293V70.5C79 71.3284 78.3284 72 77.5 72C76.6716 72 76 71.3284 76 70.5V68H66V70.5C66 71.3284 65.3284 72 64.5 72C63.6716 72 63 71.3284 63 70.5V67.8293C61.8348 67.4175 61 66.3062 61 65C61 66.3062 60.1652 67.4175 59 67.8293V70.5C59 71.3284 58.3284 72 57.5 72C56.6716 72 56 71.3284 56 70.5V68H46V70.5C46 71.3284 45.3284 72 44.5 72C43.6716 72 43 71.3284 43 70.5V67.8293C41.8348 67.4175 41 66.3062 41 65C41 66.3062 40.1652 67.4175 39 67.8293V70.5C39 71.3284 38.3284 72 37.5 72C36.6716 72 36 71.3284 36 70.5V68H26V70.5C26 71.3284 25.3284 72 24.5 72C23.6716 72 23 71.3284 23 70.5V67.8293C21.8348 67.4175 21 66.3062 21 65V31Z",
    fill: "#FFD56A"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_1222)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 28,
    width: 10,
    height: 44,
    fill: "#122771",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 28,
    width: 10,
    height: 44,
    fill: "#122771",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 28,
    width: 10,
    height: 44,
    fill: "#122771",
    fillOpacity: 0.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockerLarge);
export default __webpack_public_path__ + "static/media/LockerLarge.bb3540eb077b0568b04be37667939c44.svg";
export { ForwardRef as ReactComponent };